import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { MdLocalPhone, MdLocationPin, MdEmail } from 'react-icons/md';

const Contact = () => {
  return (
    <div id="contact">
      <Header />
      <main>
        <section className="intro-area">
          <div className="intro-area_wrap center container">
            <h1>Contact Us</h1>
          </div>
        </section>
        <section className="map-area container">
          <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3964.728860088821!2d3.5525253147702185!3d6.428868995348711!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sBlock%20B2%2C%20Nile%20Road%2C%20Ocean%20Bay%20Estate%20Orchid%20Road%2C%20Lekki-Phase%20II%20Lagos%2C%20Nigeria.!5e0!3m2!1sen!2sng!4v1640777180015!5m2!1sen!2sng" title="Island Luxury Location" style={{border: 0, width: "100%", height: "100%"}}></iframe>
        </section>
        <section className="contact-area container">
          <h2>Get in Touch</h2>
          <div className="contact-area_grid">
            <form>
              <input type="text" placeholder="Enter full name" required />
              <input type="email" placeholder="Enter email address" required />
              <input type="text" placeholder="Enter Subject" required />
              <textarea  placeholder="Enter Message" rows="5" />
              <button type="submit">Send</button>
            </form>
            <div className="contact-details">
              <div className="contact-detail_item">
                <MdLocationPin size={25} />
                <div>
                  <p>Block B2, Nile Road, Ocean Bay Estate Orchid Road</p>
                  <p>Lekki-Phase II Lagos, Nigeria.</p>
                </div>
              </div>
              <div className="contact-detail_item">
                <MdLocalPhone size={25} />
                <div>
                  <p>(+234) 913 900 7777</p>
                  <p>Mon to Fri 9am to 6pm</p>
                </div>
              </div>
              <div className="contact-detail_item">
                <MdEmail size={25} />
                <div>
                  <p>support@islandluxurypropertylistings.com</p>
                  <p>Send in your query anytime!</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </main>
    </div>
  )
}

export default Contact;